import { css } from '@emotion/css';
import { RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

import { resetLegacyLcBorderBox } from 'styles/reset-border-box';

export const migrationAlert = css`
  &[class] {
    background-color: #ebeb01;
    color: var(--content-locked-default, #131317);
  }
`;

export const migrationAlertMessage = css`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
`;

export const migrationAlertCta = css`
  &[class] {
    background-color: #fff;
    border: 1px solid #c9c9cd;
    color: var(--content-locked-default, #131317);
  }
`;

export const modal = css`
  ${resetLegacyLcBorderBox};
  position: relative;
  width: min(600px, calc(100vw - 32px));
  max-width: 600px;
  overflow: hidden;
`;

export const closeButton = css`
  position: absolute;
  top: var(${SpacingToken.Spacing2});
  right: var(${SpacingToken.Spacing2});
  z-index: 1;
`;

export const media = css`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 592 / 240;
  object-fit: cover;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(${SpacingToken.Spacing12}) var(${SpacingToken.Spacing8}) var(${SpacingToken.Spacing16});
  text-align: center;
`;

export const title = css`
  margin: 0 0 var(${SpacingToken.Spacing4});
`;

export const description = css`
  margin: 0;
  max-width: 480px;
`;

export const actions = css`
  display: flex;
  gap: var(${SpacingToken.Spacing2});
  justify-content: center;
  margin-top: var(${SpacingToken.Spacing8});

  button {
    border-radius: var(${RadiusToken.Radius3});
  }
`;
